import { render, staticRenderFns } from "./pageadmin.vue?vue&type=template&id=585989b3"
import script from "./pageadmin.vue?vue&type=script&lang=js"
export * from "./pageadmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports